import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from '../../../badge/src';
import { Text } from '../../../typography/src';
import { SideNavLink } from './side_nav_link.component';
export const SideNavStaticSection = ({ LinkComponent, activeLinkPath, isCollapsed, item, onLinkClick, }) => {
    const links = item.links.filter((link) => !link.hidden);
    if (links.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `
          nucleus-group nucleus-box-border nucleus-flex nucleus-w-full nucleus-select-none nucleus-items-center
          nucleus-gap-2 nucleus-border-none nucleus-font-sans nucleus-rounded-md nucleus-px-2 nucleus-py-1 
          nucleus-text-text-secondary nucleus-bg-transparent
        ${isCollapsed ? 'nucleus-invisible' : ''}
        ${item.startsNewGroup ? 'nucleus-mt-6' : 'nucleus-mt-0.5'}`, tabIndex: 0, children: [typeof item.title === 'string' ? (_jsx(Text, { size: 'xs', className: 'nucleus-font-normal nucleus-flex-1 nucleus-truncate', children: item.title })) : (item.title), item.badgeProps && _jsx(Badge, Object.assign({}, item.badgeProps))] }), _jsx("div", { className: 'nucleus-box-border nucleus-flex nucleus-flex-col nucleus-font-sans nucleus-pb-4', children: item.links.map((link) => {
                    if (link.hidden) {
                        return null;
                    }
                    return (_jsx(SideNavLink, { LinkComponent: LinkComponent, activeLinkPath: activeLinkPath, item: link, isCollapsed: isCollapsed, onLinkClick: onLinkClick }, link.path));
                }) })] }));
};
//# sourceMappingURL=side_nav_static_section.component.js.map